import { CameraOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { toast } from '@crosscode/gravity-components'
import { PriceCheckerActions } from './DeviceActions'
import type { PriceChecker } from './utils'
import styles from '@/pages/HomePage.module.css'

function copyIp(ip?: string) {
  if (!ip) return
  void navigator.clipboard?.writeText(ip)
  toast.success('IP скопирован')
}

interface Props {
  checker: PriceChecker
  statusLabel?: string
}

export function PriceCheckerGridCard({ checker, statusLabel }: Props) {
  const title = checker.name || `Прайс-чекер ${checker.id}`
  const offline = statusLabel ? /оффлайн/i.test(statusLabel) : checker.online === false
  const ping = statusLabel?.match(/\d+(\.\d+)?ms/i)?.[0] ?? null
  const isOn = Boolean(statusLabel && /онлайн/i.test(statusLabel))
  const statusText = offline ? 'Оффлайн' : isOn ? 'Онлайн' : 'Проверка…'

  return (
    <article
      className={`${styles.deviceCard} ${offline ? styles.deviceCardOffline : isOn ? styles.deviceCardOnline : ''}`}
    >
      <div className={styles.deviceCardHead}>
        <span className={styles.deviceCardIcon}>
          <CameraOutlined />
        </span>
        <div className={styles.deviceCardTitle}>
          <strong>{title}</strong>
          <span className={styles.typeChip}>Прайс-чекер</span>
        </div>
        <span
          className={[
            styles.statusCell,
            isOn ? styles.statusOn : '',
            offline ? styles.statusOff : '',
            !isOn && !offline ? styles.statusMuted : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <i className={styles.statusDot} aria-hidden />
          {statusText}
        </span>
      </div>
      <div className={styles.deviceCardMeta}>
        <Tooltip title="Скопировать IP">
          <button type="button" className={styles.ipBtn} onClick={() => copyIp(checker.ip)}>
            {checker.ip || '—'}
          </button>
        </Tooltip>
        {ping ? <span className={styles.statusPing}>{ping}</span> : null}
      </div>
      <div className={styles.deviceCardActions}>
        <PriceCheckerActions checkerId={checker.id} />
      </div>
    </article>
  )
}
